/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * DatePicker header single styles
 *
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.10.0
 */

import styled from 'styled-components';

import { fonts } from '../../../../../theme';

export const DatePickerHeaderTitleSingleStyled = styled.div.attrs({
    className: 'date-picker__header-title',
})`
    flex-grow: 1;
    text-align: center;
    ${fonts.textHeader5}
`
